import { useState, useEffect } from "react";

import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import TextField from "@mui/material/TextField";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

export default function EditBackCard(props) {
  const { pickCard, handleEditedItems } = props;
  const [cardData, setCardData] = useState([]);

  const handleData = (secendLoad, value, index) => {
    if (secendLoad) {
      const cp = [...cardData]
      cp[index] = value
      handleEditedItems({ backCard: cp });
      setCardData(cp);
    } else {
      setCardData(value);
    }
  };
  useEffect(() => {
    console.log(pickCard["backCard"])
    handleData(false, pickCard["backCard"]);
  }, []);

  return (
    <Item>
      {cardData.map((value, index) => (<TextField
        id="filled-textarea"
        key={`editCard=${index}`}
        value={value}
        sx={{ m: .1 }}
        size="small"
        onChange={(e) => {
          handleData(true, e.target.value, index);
        }}
        multiline
        variant="filled"
      />))}
    </Item>
  );
}
